import { jsxs, jsx } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
import "../shared/quiz-blank.js";
import { KatexText } from "../shared/katex-text.js";
import "react";
import "react-i18next";
import "../../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import "../../../utils/quiz-parser.js";
import "../../../context/DevToolsContext.js";
import { getImageUrl, getPrintScale, PrintQuizTitle, PrintQuizImage, getStyles, PrintOrderBoxes } from "./print-common.js";
const CIRCLED_NUMBERS = ["①", "②", "③", "④", "⑤", "⑥", "⑦", "⑧", "⑨", "⑩"];
function OrderingPrint({
  quiz,
  number,
  showCorrectAnswers = false,
  correctAnswers,
  compact
}) {
  const s = getStyles(compact);
  const imageUrl = getImageUrl(quiz.image, quiz.imagePrint);
  const printScale = getPrintScale(quiz.image, quiz.imagePrint);
  const correctOrderMap = /* @__PURE__ */ new Map();
  if (showCorrectAnswers && correctAnswers) {
    correctAnswers.forEach((key, idx) => {
      const choiceIdx = quiz.choices.findIndex((c) => c.key === key);
      if (choiceIdx !== -1) {
        correctOrderMap.set(idx, choiceIdx + 1);
      }
    });
  }
  return /* @__PURE__ */ jsxs("div", { className: cn(s.container, s.quizSection), children: [
    /* @__PURE__ */ jsx(PrintQuizTitle, { number, compact, children: /* @__PURE__ */ jsx(KatexText, { text: quiz.title }) }),
    imageUrl && /* @__PURE__ */ jsx(PrintQuizImage, { src: imageUrl, printScale }),
    /* @__PURE__ */ jsx("div", { className: "pl-[40px] w-full", children: /* @__PURE__ */ jsxs("div", { className: `relative bg-[#f2f2f2] rounded-[16px] ${compact ? "pt-[38px] pb-[16px] px-[20px]" : "pt-[48px] pb-[24px] px-[24px]"}`, children: [
      /* @__PURE__ */ jsx("span", { className: `absolute top-0 ${compact ? "left-[20px] w-[54px] justify-center" : "left-[24px]"} bg-[#999] text-white h-[28px] rounded-bl-[8px] rounded-br-[8px] px-[12px] flex items-center text-[14px] font-bold`, children: "보기" }),
      /* @__PURE__ */ jsx("div", { style: {
        display: "grid",
        gridTemplateColumns: quiz.subtype === "full" ? "1fr" : quiz.subtype === "2by2" ? "repeat(2, 1fr)" : `repeat(${quiz.choices.length}, 1fr)`,
        gap: 16
      }, children: quiz.choices.map((choice, idx) => {
        const choiceImageUrl = getImageUrl(choice.image);
        return /* @__PURE__ */ jsxs(
          "div",
          {
            className: cn(
              s.inputBoxSm,
              `flex items-center gap-[8px] px-[12px] w-full h-auto! ${quiz.subtype === "full" || quiz.subtype === "2by2" ? compact ? "min-h-[35px]" : "min-h-[40px]" : "min-h-[40px]"}`
            ),
            children: [
              /* @__PURE__ */ jsx("span", { className: "text-[20px] text-black shrink-0", children: CIRCLED_NUMBERS[idx] || `${idx + 1}` }),
              choiceImageUrl && /* @__PURE__ */ jsx("img", { src: choiceImageUrl, alt: "item", className: "max-h-[28px] w-auto object-contain shrink-0" }),
              choice.answer && /* @__PURE__ */ jsx("span", { className: "text-[16px] text-black tracking-[-0.096px]", children: /* @__PURE__ */ jsx(KatexText, { text: choice.answer }) })
            ]
          },
          choice.key
        );
      }) })
    ] }) }),
    /* @__PURE__ */ jsx("div", { className: "w-full flex justify-center", children: /* @__PURE__ */ jsx(
      PrintOrderBoxes,
      {
        count: quiz.choices.length,
        correctOrder: correctOrderMap,
        showCorrectAnswers,
        compact
      }
    ) })
  ] });
}
export {
  OrderingPrint
};
//# sourceMappingURL=ordering-print.js.map
